import jQuery from 'jquery';
import URI from 'urijs';
import _String from 'underscore.string';

const fullWidth = 1090;

const widthPerWindowSize = {
	'SMALL': 360,
	'MEDIUM': 520,
	'FULL': fullWidth
};

const openUrlInOverlay = function(url, queryAttrs, width, triggerElement, title){
	const uri = new URI(url);
	uri.addQuery('showInLayer', 'true');
	uri.addQuery('tuiel', kps.uiel);
	
	if(typeof queryAttrs !== 'undefined'){
		jQuery.each(queryAttrs, function(queryName, queryValue){
			uri.addQuery(queryName, queryValue);
		});
	}
	const dfd  = jQuery.Deferred();

	const options = {
		title: title,
		maxWidth: '95%',
		maxHeight: '90%',
		minWidth: '55%',
		width: width,
		iframe: true,
		url: uri.unicode(),
		listeners: {
			onClose: function(){
				dfd.resolve();
			},
		}
	};
	$.ep.overlayWidget.mount(options, triggerElement);
	
	return dfd;
}

const maxWidthForSize = function(size){
	return widthPerWindowSize[size];
}

const defaultFunc = function(){
	jQuery(function(){
		const body = jQuery('body');
		const isInLayer = body.hasClass('in-layer') && typeof window.parent !== 'undefined';
		
		if(!isInLayer){
			var inLayerLinkListener = function(evt){
				const elm = jQuery(this);
				if(elm.data('et-title') === 'Kontakt' && elm.parents('.checkout-footer-component').length !== 0){
					return;
				}	
				
				const href = elm.attr('href') ?? elm.data('href');
				const indexedQueryAttrs = {};
				
				const datas = elm.data();
				jQuery.each(datas, function(name, value) {
					const isKey = _String.startsWith(name, 'queryKey');
					const isValue = _String.startsWith(name, 'queryValue')
					
					if(isKey || isValue){
						const idxStart = (isKey)?8:10;
						const idx = name.substring(idxStart);

						if(typeof indexedQueryAttrs[idx] === 'undefined'){
							indexedQueryAttrs[idx] = {};
						}
						
						if(isKey){
							indexedQueryAttrs[idx].key = value;
						}else{
							indexedQueryAttrs[idx].value = value;
						}
					}
				});
				
				const queryAttrs = {};
				jQuery.each(indexedQueryAttrs, function(idx, queryObj) {
					queryAttrs[queryObj.key] = queryObj.value;
				});

				let size = elm.attr('data-window-size');
				const width = widthPerWindowSize[size] ?? widthPerWindowSize.FULL;

				const title = elm.data('overlayTitle') ?? elm.attr('aria-label') ?? elm.text().trim();
				openUrlInOverlay(href, queryAttrs, width, elm, title);

				evt.preventDefault();
				evt.stopPropagation();
			};

			jQuery(
				'body.template-pages-templates-epResponsiveCheckoutPageTemplate .footer-slot .normal-links button[data-href], ' +
				'body.template-pages-templates-epResponsiveCheckoutPageTemplate .footer-slot .payment-links a[href]:not([target=_blank]), ' +
				'.registration-agb button[data-href]:not(.no-layer), ' +
				'.terms-and-confirm button[data-href]:not(.no-layer), ' +
				'.altgeraete-terms-confirm button[data-href]:not(.no-layer), ' +
				'.checkout-summary-component .newsletter-subcomponent button[data-href]:not(.no-layer), ' +
				'.checkout-newsletter-registraction-component button[data-href]:not(.no-layer)'
			).click(inLayerLinkListener);
			
			jQuery('body').on('click', '.in-layer-link', inLayerLinkListener);
		}
		
		if(isInLayer){
			//Modify links
			body.on('click', 'a[href]', function(event){
				if(event.which === 1){
					const elm = jQuery(this);
					
					let target = elm.attr('target');
					if(typeof target === 'undefined'){
						target = "_self";
					}
					
					if(target === '_self'){
						const originalHref = elm.attr('href');
						
						const currentUri = new URI();
						currentUri.normalize();
						const currentProtocol = currentUri.protocol();
						const currentHostname = currentUri.hostname();
						const currentPort = currentUri.port();
						
						let linkUri = new URI(originalHref);
						linkUri = linkUri.absoluteTo(window.location.href)
							.normalize();
						const linkProtocol = linkUri.protocol();
						const linkHostname = linkUri.hostname();
						const linkPort = linkUri.port();
						
						const isLocalCall = (linkProtocol === currentProtocol) && (linkHostname === currentHostname) && (linkPort === currentPort);
					
						if(isLocalCall){
							linkUri.addQuery('showInLayer', true);
							linkUri.addQuery('tuiel', kps.uiel);
							
							elm.attr('href', linkUri.unicode());
						}else{
							elm.attr('target', '_blank');
						}
					}
				}
			});
		}
	});
}

export {
	defaultFunc as default,
	maxWidthForSize,
	openUrlInOverlay
}
